export default __webpack_public_path__ + "a66396d9194c39a7a7c8e2b4ac7bfd4d.svg";